import React from 'react';
export function HeroSection() {
  return <section aria-label="Presentación del ProfePack" className="bg-brand-dark text-white md:pt-20 pb-16 md:pb-24 px-4 relative pt-[10px]" data-id="element-132">
      <div className="max-w-5xl mx-auto relative z-10 w-full flex flex-col items-center text-center" data-id="element-133">
        <div className="flex flex-col items-center w-full" data-id="element-134">
          <div className="flex items-center gap-2 text-brand-accent font-badge font-bold tracking-widest text-sm uppercase mb-4 md:mb-8" data-id="element-135">
            <span className="text-xl" aria-hidden="true" data-id="element-136">
              🔬
            </span>{' '}
            PROFEPACK
          </div>

          <h1 className="sm:text-4xl md:text-7xl lg:text-8xl tracking-tight px-2 text-[40px] font-[900] font-sans pl-[0px] pr-[0px] mt-[-20px] mb-[-20px] leading-[0.95]" data-id="element-137">
            Todo tu año de Física y Química
            <br data-id="element-138" />
            <span className="text-brand-accent" data-id="element-139">resuelto.</span>
          </h1>
        </div>

        <div className="w-full max-w-[220px] sm:max-w-xs md:max-w-lg mx-auto relative mt-6 md:mt-12 mb-6 md:mb-12" data-id="element-140">
          <img src="https://cdn.magicpatterns.com/uploads/xreJrC7QZ2pqEundwF9PmH/Sin-titulo-_420-x-420-px_.webp" alt="Megapack Física y Química Lista — 12 tomos completos para docentes de secundaria" className="w-full h-auto object-contain relative z-10 mt-[-5px] mb-[-10px]" loading="eager" fetchPriority="high" width={385} height={385} data-id="element-141" />
        </div>

        <div className="flex flex-col items-center w-full max-w-3xl" data-id="element-142">
          <p className="text-lg sm:text-xl md:text-3xl text-brand-accent font-heading font-bold md:mb-6 px-2 mb-[5px]" data-id="element-143">
            "Listo para usar. Sin buscar más."
          </p>

          <p className="text-base md:text-xl text-white/80 md:mb-10 leading-relaxed px-2 mb-[10px]" data-id="element-144">
            El sistema que usan docentes de Física y Química de secundaria en
            Argentina para planificar{' '}
            <span className="text-white font-bold" data-id="element-145">
              todo el año en una tarde
            </span>
          </p>

          <div className="flex flex-nowrap justify-center gap-1.5 md:gap-3 mb-6 md:mb-10 w-full mx-auto px-1" data-id="element-146">
            <span className="text-[10px] md:text-sm font-medium border border-brand-border bg-brand-card px-2 md:px-4 py-1 md:py-2 rounded-full text-white/90 whitespace-nowrap" data-id="element-147">
              📄 100% PDF
            </span>
            <span className="text-[10px] md:text-sm font-medium border border-brand-border bg-brand-card px-2 md:px-4 py-1 md:py-2 rounded-full text-white/90 whitespace-nowrap" data-id="element-148">
              ⚡ Acceso inmediato
            </span>
            <span className="text-[10px] md:text-sm font-medium border border-brand-border bg-brand-card px-2 md:px-4 py-1 md:py-2 rounded-full text-white/90 whitespace-nowrap" data-id="element-149">
              🇦🇷 Currículo argentino
            </span>
          </div>

          <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })} className="w-full sm:w-auto bg-brand-accent hover:bg-brand-accent-dim active:scale-95 text-brand-dark font-black text-xl md:text-3xl py-5 md:py-6 px-10 md:px-14 rounded-2xl transition-colors flex items-center justify-center mb-5 md:mb-8 mx-4 sm:mx-0 ml-[50px] mr-[50px] pl-[0px] pr-[0px]" data-id="element-150">
            → QUIERO MI PROFEPACK AHORA
          </button>

          <div className="flex flex-wrap justify-center gap-x-4 md:gap-x-8 gap-y-2 text-xs md:text-sm text-white/70 font-medium" data-id="element-151">
            <span data-id="element-152">🛡️ Garantía 7 días sin preguntas</span>
            <span data-id="element-153">🔒 Pago 100% seguro</span>
            <span data-id="element-154">💳 Mercado Pago</span>
          </div>
        </div>

        {/* Stats Bar */}
        <div className="mt-12 md:mt-24 w-full grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 bg-brand-card border border-brand-border rounded-2xl md:rounded-3xl p-5 md:p-8" data-id="element-155">
          <div className="text-center" data-id="element-156">
            <div className="text-2xl md:text-4xl font-heading font-bold text-brand-accent mb-1" data-id="element-157">
              +1.500
            </div>
            <div className="text-xs md:text-sm text-white/70 font-medium uppercase tracking-wider" data-id="element-158">
              docentes confían
            </div>
          </div>
          <div className="text-center" data-id="element-159">
            <div className="text-2xl md:text-4xl font-heading font-bold text-brand-accent mb-1" data-id="element-160">
              12
            </div>
            <div className="text-xs md:text-sm text-white/70 font-medium uppercase tracking-wider" data-id="element-161">
              Volúmenes listos
            </div>
          </div>
          <div className="text-center" data-id="element-162">
            <div className="text-2xl md:text-4xl font-heading font-bold text-brand-accent mb-1" data-id="element-163">
              4.9/5 ⭐
            </div>
            <div className="text-xs md:text-sm text-white/70 font-medium uppercase tracking-wider" data-id="element-164">
              calificación
            </div>
          </div>
          <div className="text-center" data-id="element-165">
            <div className="text-2xl md:text-4xl font-heading font-bold text-brand-accent mb-1" data-id="element-166">
              🇦🇷
            </div>
            <div className="text-xs md:text-sm text-white/70 font-medium uppercase tracking-wider" data-id="element-167">
              Todo el país
            </div>
          </div>
        </div>

        {/* Hero Testimonials */}
        <div className="mt-8 md:mt-12 w-full grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-168">
          {[{
          initials: 'MG',
          name: 'Marcela G.',
          loc: 'Córdoba | Secundaria',
          quote: 'Organicé todo el año de Física en una tarde'
        }, {
          initials: 'LP',
          name: 'Laura P.',
          loc: 'Rosario | Secundaria',
          quote: 'Mis clases de Química por fin tienen estructura real'
        }, {
          initials: 'RM',
          name: 'Roberto M.',
          loc: 'Buenos Aires | Física y Química',
          quote: 'Nunca más llegué a clase sin saber qué hacer'
        }].map((test, i) => <div key={i} className="bg-brand-card border border-brand-border rounded-xl md:rounded-2xl p-4 md:p-6 text-left" data-id="element-169">
              <div className="flex items-center gap-3 mb-3" data-id="element-170">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-brand-accent/10 border border-brand-accent/20 flex items-center justify-center font-heading font-bold text-brand-accent text-sm md:text-base" aria-hidden="true" data-id="element-171">
                  {test.initials}
                </div>
                <span className="text-brand-accent text-sm" aria-label="5 estrellas" data-id="element-172">
                  ⭐⭐⭐⭐⭐
                </span>
              </div>
              <p className="text-white/90 font-medium italic mb-3 leading-relaxed text-sm md:text-base" data-id="element-173">
                "{test.quote}"
              </p>
              <div className="text-[10px] md:text-xs text-white/70 uppercase tracking-wider font-bold" data-id="element-174">
                — {test.name}, {test.loc}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}